export type SupportWidgetUser = {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  liveChatKey?: string;
  chatwootIdentifierHash?: string;
  isMember?: boolean;
  ownerId?: string | number;
  subscriptionPlan?: string | null;
  language?: string | null;
};

export const getSupportWidgetIdentifier = (user: SupportWidgetUser) => user.id;

export const getSupportWidgetName = (user: SupportWidgetUser) =>
  [user.firstName, user.lastName].filter(Boolean).join(' ').trim() || undefined;

export const getSupportWidgetCustomAttributes = (user: SupportWidgetUser) => ({
  user_id: getSupportWidgetIdentifier(user),
  member_id: user.isMember ? user.id : null,
  bemob_owner_id: user.isMember ? user.ownerId ?? null : null,
  bemob_plan: user.subscriptionPlan ?? null,
  bemob_language: user.language ?? null,
});

export const getIntercomBootPayload = (user: SupportWidgetUser) => ({
  user_id: getSupportWidgetIdentifier(user),
  ...getSupportWidgetCustomAttributes(user),
  name: getSupportWidgetName(user),
  email: user.email,
  hide_default_launcher: true,
  user_hash: user.liveChatKey,
});
